export const legacyHost = 'www.yammer.com';
export const glammerDomain = 'web.yammer.com';
export const engageDomain = 'engage.cloud.microsoft';
